var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileHeaderCover2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 600,
    zoomAndPan: "magnify",
    viewBox: "0 0 450 74.999997",
    height: 100,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "36884e3bd5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 162 0 L 162 75 L 0 75 Z M 0 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ff777a5f7e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 112.042969 -45.886719 L 161.855469 93.210938 L 22.753906 143.023438 L -27.058594 3.925781 Z M 112.042969 -45.886719 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b9b6a9ad79"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 112.042969 -45.886719 L 161.855469 93.210938 L 22.753906 143.023438 L -27.058594 3.925781 Z M 112.042969 -45.886719 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6aeb80c5fe"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 80 28 L 450 28 L 450 75 L 80 75 Z M 80 28 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5608c271ef"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 552.945312 115.140625 L 76.84375 127.078125 L 74.609375 37.855469 L 550.707031 25.917969 Z M 552.945312 115.140625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dce4394835"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 552.945312 115.140625 L 76.84375 127.078125 L 74.609375 37.855469 L 550.707031 25.917969 Z M 552.945312 115.140625 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#36884e3bd5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ff777a5f7e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b9b6a9ad79)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f8f7f6",
    d: "M -23.511719 8.394531 C -23.796875 12.925781 -6.925781 17.832031 -6.25 28.152344 C -6.09375 30.53125 -6.808594 32.8125 -7.089844 35.136719 C -7.929688 42.136719 -5.785156 50.601562 0.152344 55.011719 C 5.59375 59.054688 12.625 62.589844 19.617188 62.167969 C 26.707031 61.742188 35.007812 57.882812 41.855469 60.730469 C 50.933594 64.503906 50.121094 67.550781 54.0625 74.816406 C 58.859375 83.671875 68.644531 91.78125 79.085938 92.269531 C 92.816406 92.914062 105.378906 78.4375 120.625 78.511719 C 128.4375 78.550781 138.132812 79.984375 144.824219 84.324219 C 147.277344 85.917969 149.21875 88.148438 151.582031 89.859375 C 153.105469 90.96875 159.121094 94.480469 161.207031 92.300781 C 161.441406 92.054688 159.695312 88.085938 159.589844 87.789062 C 157.960938 83.234375 155.433594 79.132812 153.613281 74.652344 C 151.910156 70.464844 149.972656 67.222656 146.792969 64.046875 C 141.492188 58.753906 135.117188 54.273438 127.363281 53.339844 C 124.203125 52.960938 113.847656 58.445312 110.054688 59.222656 C 105.375 60.179688 99.5 58.566406 95.261719 56.5625 C 82.945312 50.742188 78.453125 40.128906 71.488281 29.273438 C 67.707031 23.390625 62.683594 18.28125 57.816406 13.324219 C 52.773438 8.1875 46.738281 2.777344 39.226562 1.84375 C 31.625 0.898438 27.398438 6.242188 24.199219 12.316406 C 22.359375 15.8125 19.71875 22.53125 14.667969 22.570312 C 10.082031 22.605469 4.488281 17.074219 2.664062 13.5 C 0.25 8.765625 0.0976562 4.171875 -4.53125 0.960938 C -9.335938 -2.375 -23.222656 3.867188 -23.511719 8.394531 Z M -23.511719 8.394531 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6aeb80c5fe)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5608c271ef)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dce4394835)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f8f7f6",
    d: "M 265.230469 122.332031 L 267.277344 122.277344 C 358.542969 117.371094 419.429688 112.984375 449.929688 109.121094 C 472.519531 106.386719 492.417969 101.710938 509.628906 95.097656 C 537.472656 80.96875 548.449219 65.628906 542.5625 49.078125 C 539.414062 41.972656 531.355469 36.453125 518.386719 32.515625 C 505.441406 28.941406 492.808594 27.507812 480.476562 28.21875 C 472.355469 28.433594 463.191406 29.113281 452.980469 30.261719 C 394.472656 39.636719 345.210938 45.921875 305.195312 49.125 C 291.570312 50.304688 270.921875 51.207031 243.246094 51.832031 C 222.457031 52.320312 183.324219 52.871094 125.835938 53.480469 C 110.234375 54.402344 99.375 56.269531 93.269531 59.078125 C 81.730469 62.992188 77.730469 70.652344 81.269531 82.058594 C 83.804688 91.515625 95.910156 100.925781 117.585938 110.292969 C 124.632812 113.425781 148.183594 116.855469 188.242188 120.582031 C 212.574219 122.425781 238.234375 123.007812 265.230469 122.332031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileHeaderCover2);
export default __webpack_public_path__ + "static/media/mobile_header_cover2.342f3c19ba30852ce5961c41bd9bf40a.svg";
export { ForwardRef as ReactComponent };